import $i18n from '~/services/i18n';

const isDev = import.meta.env.VITE_NODE_ENV === 'dev';
const monthName = new Date().toLocaleString('default', { month: 'long' });

export const BTS_DATE = '18 Aug 2023 00:00:00 GMT';
export const FC_BTS_DATE = '18 JAN 2024 00:00:00 GMT';

export const TAGS = {
  created: {
    label: $i18n('Recently created'),
    icon: 'fas fa-clock',
    value: 'RECENTLY_CREATED',
  },
  trending: {
    label: $i18n('Trending'),
    icon: 'fas fa-arrow-trend-up',
    value: 'TRENDING',
  },
  topPick: {
    label: $i18n('Top pick for {$1}', [monthName]),
    icon: 'fas fa-thumbs-up',
    value: 'TOP_PICKS_FOR_MONTH',
  },
  previousHosted: {
    label: $i18n('Previously hosted by you'),
    icon: 'fas fa-rotate-right',
    value: 'PREVIOUSLY_HOSTED',
  },
  district: {
    label: $i18n('From your district'),
    icon: 'fas fa-school',
    value: 'FROM_YOUR_DISTRICT',
  },
};

export const DEMO_QUIZ_SCHOOLS_IDS = isDev
  ? {
      'Mathematics': '64b522f7e47ef100076e48e3',
      'Science': '64b5230ddf93350007007e74',
      'English': '64b52318df93350007007e76',
      'Social Studies': '64b52322e47ef100076e48ed',
      'DEFAULT': '64b8dd4295a6db0007864920',
    }
  : {
      'Mathematics': '64b4f2f9495d3d001d035d19',
      'Science': '64b4f42e1e1d4e001d4b1cf7',
      'English': '64b4eeb4495d3d001d035ce6',
      'Social Studies': '64b4f51a1e1d4e001d4b1d31',
      'DEFAULT': '64b4f91c495d3d001d035dcb',
    };

export const DEMO_QUIZ_SCHOOLS_SUPPORTED_SUBJECTS = ['Mathematics', 'Science', 'English', 'Social Studies'];
